

















































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import ScrollToBottomVue from "../../components/ScrollToBottom.vue";
@Component({
    ...mapGetters(["account"]),
    components: {
        "scroll-to-bottom": ScrollToBottomVue
    }
})
export default class AssignAccount extends Vue {
    @Prop({ type: Array })
    bookList!: AccountBookList.AccountBook[];

    accounterList: Account[] = [];
    accountList: AccountBookList.AccountBook[] = JSON.parse(JSON.stringify(this.bookList));
    page: number = 0;
    size: number = 15;
    totalPages: number = 0;
    query: string = "";
    accounterVal: Account | null = null;

    mounted() {
        this.getAccounterList();
    }

    getAccounterList() {
        let page = this.query.trim() != "" ? 0 : this.page;
        Vue.axios
            .post(`accounts/find?page=${page}&size=${this.size}`, {
                query: this.query,
                accounterNo: this.$store.state.account.no
            })
            .then(res => {
                if (this.query === "") {
                    for (let i = 0; i < res.data.content.length; i++) {
                        this.accounterList.push(res.data.content[i]);
                    }
                }else{
                    this.accounterList=res.data.content
                }
                this.totalPages = res.data.totalPages;
            });
    }

    // 获取会计信息
    changeAccounter(value: Account) { }

    // 删除客户
    deleteCustomer(tag: AccountBookList.AccountBook) {
        if (this.accountList) {
            for (let i = 0; i < this.accountList.length; i++) {
                if (this.accountList[i].id == tag.id) {
                    this.accountList.splice(i, 1);
                }
            }
            if (this.accountList.length == 0) {
                this.close();
            }
        }
    }

    // 点击保存
    save() {
        if (this.accounterVal === null) {
            this.$message.warning("请选择新的记账会计！");
        } else {
            Vue.axios
                .post(`accountbooks/assign`, {
                    accountBookDtoList: this.accountList,
                    accounterNo: this.accounterVal.no
                })
                .then(res => {
                    this.$emit("success", true);
                });
        }
    }

    // 关闭弹窗
    close() {
        this.$emit("close");
    }
    acounterQuery: string = "";
    remoteMethod(query: string) {
        this.acounterQuery = query;
        this.page = 0;
        this.accounterList = [];
        this.getAccounterList();
        if (query == "") {
            this.accounterVal = null;
            this.page = 0;
        }
    }
    // 搜索
    searchAccounter(query: string) {
        this.query = query;
        if (query === "") {
            this.page = 0;
            this.accounterList = [];
        }
        this.getAccounterList();
    }
}
